import React, { ReactNode } from 'react'
import { StackProps, Stack, Box, IconButton, Tooltip, Typography, TypographyOwnProps } from '@mui/material'

import { ecolors } from 'containers/app/theme'
import InfoIcon from '@mui/icons-material/Info'
import { TypographyProps } from '@mui/material'

interface CustomStackProps extends StackProps {
  children?: ReactNode // Para que el componente acepte hijos como cualquier otro componente de MUI
  title?: string
  variant?: TypographyProps['variant']
}

function SectionTitle({ title, variant = 'h5' }: { title: String; variant?: TypographyProps['variant'] }) {
  return (
    <Box component="section">
      <Stack direction="row" alignItems="center">
        <Typography variant={variant}>{title}</Typography>
      </Stack>
    </Box>
  )
}

const SectionHeader: React.FC<CustomStackProps> = ({ title, variant, children, ...props }) => {
  return (
    <Stack direction="row" height={75} alignItems="center" spacing={2} sx={{ px: 3 }} justifyContent="space-between" {...props}>
      {title && <SectionTitle title={title} variant={variant} />}
      {children}
    </Stack>
  )
}

export default SectionHeader
